<template>
	<div class="answer">
		<!-- banner -->
		<div class="banner">
			<el-carousel :height="bannerHeight+'px'">
				<el-carousel-item v-for="(item, index) in sliders" :key="index">
						<img style="width:100%;height: auto" :src="item.img" class="slider_img" @click="getOpenMinChengXuLink">						
				</el-carousel-item>
			</el-carousel>
		</div>
		<div class="answer-con">
			<div class="head-label">
				<div class="f36">典当须知</div>
				<div class="f14 red">PAWN INSTRUCTIONS</div>
			</div>
			<div class="answer-list">
				<!-- <div class="flex">
					<div @click="activeIndex = i" v-for="(item, i) in answerArr" :key="i" class="answer-item">
						<span :class="activeIndex == i ? 'active' : ''" class="name">{{ item.name }}</span>
					</div>
				</div> -->
				<img src="../../static/answer/line.png" alt="" />
				<el-collapse v-model="activeNames" @change="handleChange">
					<el-collapse-item v-for="(item, i) in answerArr[activeIndex].answers" :key="i" :name="i">
						<template slot="title">
						    <span class="tag">Q</span><span class="tag-name">{{ item.Q }}</span>
						</template>
						<div><span class="tag">A</span>{{ item.A }}</div>
					</el-collapse-item>
				</el-collapse>
			</div>
		</div>
	</div>
</template>
<script>
	import {
		encryptLong,
		syShopSign
	} from '@/utils/rsaEncrypt'
	export default {
		name: 'Index',
		data() {
			return {
				activeNames: [0],
				activeIndex: 0,
				userName: '',
				phoneNumber: '',
				// 容器的高度
				bannerHeight: 0,
				// 瀏覽器寬度
				screeWith: 0,
				sliders: [],
				answerArr: [{
					name: '全部',
					answers: [{
						Q: '什么是典当？',
						A: '所谓典当，是指当户将其动产、财产权利作为当物质押或者抵押给典当行，交付一定比例费用，取得当金，并在约定期限内支付当金利息、偿还当金、赎回当物的行为。通俗的说，典当就是要以财物作质押，有偿有期借贷融资的一种方式。这是一种以物换钱的融资方式，只要顾客在约定时间内还本并支付一定的综合服务费(包括当物的保管费、保险费、利息等)，就可赎回当物。'
					},{
						Q: '什么东西可以典当，典当行有那些业务？',
						A: '原则上只要来源合法、产权明晰、可以依法疏通的有价值物品或财产权利都可以典当，但不同典当行具体开展的业务有不同，一般来讲房产、车辆、金银饰品、珠宝钻石、电子产品、腕表、奢侈品包包、数码产品等都可以典当。'
					},{
						Q: '典当借款同银行贷款的区别？',
						A: '1、业务方式上，典当更加灵活多样，原则上有价值的物品或财产权利都可以典当;2、典当借款手续简便快捷，一般少则几分钟，多则三五天;3、借款用途不一样，典当借款多用于救急，银行贷款多用于生产或消费:4、典当一般期限较短，最短15天，最长6个月;5、典当一般除收取当金利息外，还按当金一定比例收取综合费。'
					},{
						Q: '典当是什么流程？',
						A: '其基本流程为可简单归纳为交当、收当、存当三个步骤，具体操作程序如下:1、当户出具有效证件交付当物。2、典当行受理当物进行鉴定。3、双方约定评估价格、当金数额和典当期限并确认法定息费标准4、双方共同清点封存当物由典当行保管。5、典当行向当户出具当票发放当金。'
					},{
						Q: '典当需要提供哪些材料？',
						A: '不同典当业务需要提供材料是不一样的:1、民品：本人身份证原件，有发票最好，可适当提高当价。2、车辆：本人身份证、汽车相关证件。3、房产：户主身份证、户口本、房屋所有权证、土地使用证等，需现场察看房产注：民品即金银饰品、珠宝钻石、电子产品、奢侈品包表、数码产品、古钱币等'
					},{
						Q: '典当周期是多久？',
						A: '根据典当行管理办法有关规定，典当最短时间为7天，不足7天按7天计算，最长期限为6个月。典当到期后5天内，客户可以选择赎当，也可以根据自己需要选择赎当。'
					},{
						Q: '什么是绝当，当物绝当后如何处理？',
						A: '典当期限届满或续当期限届满后，当户应在5天内赎当或续当，逾期不赎当或续当为绝当。绝当后，绝当物估价金额不足3万元的，典当行可以自行变卖或折价处理，损益自负；当物估价金额在3万元以上的，可以按《中华人民共和国担保法》有关规定处理，也可以双方事先约定绝当后由典当行委托拍卖行公开拍卖。拍卖收入在扣除拍卖费用及当金本息后，剩余部分应当退还当户，不足部分向当户追索。'
					}]
				},{
					name: '典当物品',
					answers: [{
						Q: '如何防止套路贷？',
						A: '在现实生活中一些民间借贷机构为了谋取不正'
					}]
				},{
					name: '如何续当',
					answers: [{
						Q: '如何防止套路贷？',
						A: '在现实生活中一些民间借贷机构为了谋取不正'
					}]
				},{
					name: '如何还款',
					answers: [{
						Q: '如何防止套路贷？',
						A: '在现实生活中一些民间借贷机构为了谋取不正'
					}]
				}]
			}
		},
		created() {},
		methods: {
			handleChange(val) {
				console.log(val);
			},
			getOpenMinChengXuLink() {
				if (this.isMobile()) {
					let url = '/sy/aboutUs/getScheme';
					const timeStamp = new Date().getTime();
					const sySign = syShopSign();
					const CheckCsrf = encryptLong(sySign + timeStamp);
					this.axios.get(url, {
						headers: {
							'TimeStamp': timeStamp,
							'CheckCsrf': CheckCsrf,
							'Content-Type': 'application/x-www-form-urlencoded'
						}
					}).then(res => {
						location.href = res.data.data;
					})
				} else {
					console.log('pc端不跳转')
					return;
				}

			},
			// 判断是否是手机端，如果是，返回true
			isMobile() {
				let flag = navigator.userAgent.match(
					/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
				)
				return flag
			}
		},
		mounted() {
			this.sliders = [{
					img: require("../../static/answer/banner.png")
				}],
				// 首次加載時，初始化高度
				this.screeWith = window.innerWidth
			this.bannerHeight = 560 / 1920 * this.screeWith
			// 窗口大小發生變化
			window.onresize = () => {
				this.screeWith = window.innerWidth
				this.bannerHeight = 560 / 1920 * this.screeWith
			}
		},
		computed: {
			//计算高度
			// computeHeight() {
			//     let screenHeight = document.body.clientWidth;
			//     if (screenHeight > 415) {
			//         return '550px';
			//     } else {
			//         return '250px';
			//     }
			// },
			computeArrowImg() {
				let screenHeight = document.body.clientWidth;
				if (screenHeight > 450) {
					return require('../../static/other/arrow.png');
				} else {
					return require('../../static/other/arrow_down.png');
				}
			}

		},
	}
</script>

<style scoped>
	/* 清除banner滾動條 */
	.el-carousel--horizontal {
		overflow-x: hidden;
		overflow-y: hidden;
	}

	.el-carousel__indicator.is-active {
		border-bottom: 2px solid #DF9C03 !important;
	}

	.slider_img {
		height: 560px;
		width: 100%;
	}

	/* banner FORM style */
	.banner {
		position: relative;
	}
</style>


// WEBPACK FOOTER //
// src/view/answer.vue